import React, { PureComponent, createRef } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import { getShopList, updateShop, addShop } from '../../../actions/shop'
import { getCurrentSession } from '../../../actions/auth'
import { getTerminals } from '../../../actions/company'
import { openErrorMessage } from '../../../actions/message'

// utils
import { sortArrayByName } from '../../../utils/array'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ShopListItemContainer from '../../../components/Shops/ShopListItemContainer'
import AddShopModal from '../../../components/Modal/AddShopModal'
import { Appcues } from '../../../utils/constants'
import { validateStoreCategories } from '../../../actions/masterCatalog'

class CompanyShops extends PureComponent {
  addShopModal = createRef()

  componentDidMount() {
    this.props.dispatch(getShopList())
    this.props.dispatch(getTerminals())
  }

  onShopUpdate = (data, afterOnSave, shopStatus) => {
    if (this.validateShop(data)) {
      if (shopStatus && data && data.active != shopStatus) {
        this.props.dispatch(validateStoreCategories(data && data.id)).then((response) => {
          if (response && response.length > 0) {
            this.onError('This store has categories controlled by Master Catalog.')
          } else {
            this.props.dispatch(updateShop(data)).then((response) => {
              Appcues.track('Shop Info saved')
              this.props.dispatch(getCurrentSession())
              this.props.dispatch(getShopList())
              afterOnSave(response)
            })
          }
        })
      } else {
        this.props.dispatch(updateShop(data)).then((response) => {
          Appcues.track('Shop Info saved')
          this.props.dispatch(getCurrentSession())
          this.props.dispatch(getShopList())
          afterOnSave(response)
        })
      }
    }
  }

  openAddShopModal = () => {
    Appcues.track('Adding Shop')
    this.addShopModal.current.handleClickOpen()
  }

  addShop = (data, createCompanyProducts) => {
    this.props.dispatch(addShop(data, createCompanyProducts)).then((shop) => {
      Appcues.track('New shop saved')
      this.props.dispatch(getShopList())
      this.addShopModal.current.handleClose()
    })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  validateShop = (shop) => {
    if (!shop.name) {
      this.onError('Please enter shop name')
      return false
    }
    return true
  }

  render() {
    const { shopsList = {}, lastModified = null } = this.props.shopReducer

    const { terminals = {}, company = {} } = this.props.companyReducer

    const createCompanyProducts =
      company.platformCompanyId !== null &&
      company.platformCompanyId !== undefined &&
      company.platformCompanyId !== ''
        ? true
        : false

    const { values = [] } = shopsList

    const terminalsValues = terminals.values || []

    const sortedShops = sortArrayByName(values)
    const permitted = hasAccess()
    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {permitted ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.openAddShopModal}
              >
                Add Shop
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper>
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Shop Name</TableCell>
                      <TableCell>App Type</TableCell>
                      <TableCell>Active</TableCell>
                      <TableCell># of Assigned Terminals</TableCell>
                      {permitted ? <TableCell>Actions</TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sortedShops.map((row, index) => {
                      const shopTerminals = terminalsValues.filter((term) => term.shopId === row.id)

                      return (
                        <ShopListItemContainer
                          key={index}
                          shop={row}
                          lastModified={lastModified}
                          onShopUpdate={this.onShopUpdate}
                          shopTerminalsLength={shopTerminals.length}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <AddShopModal
            ref={this.addShopModal}
            addShop={this.addShop}
            createCompanyProducts={createCompanyProducts}
            onError={this.onError}
          />
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
}))(ContainerWithTitle(CompanyShops, 'Company Shops'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyShops.js